import * as React from 'react';
import { memo } from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

const SvgFemale = (props: SvgProps) => (
  <Svg width={24} height={24} viewBox="0 0 22 22" fill="none" {...props}>
    <Path
      d="m5.816 16.565-2.593 1.111C2.482 17.986 1 19.084 1 21.011M16.189 16.565l2.593 1.111c.741.31 2.224 1.408 2.224 3.335M7.3 7.858c.555-.432 2.074-1.297 3.704-1.297 1.63 0 3.273.865 3.89 1.297"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M5.445 10.822v-3.89c0-2.038 1.111-6.076 5.557-5.928 4.446.148 5.558 4.014 5.558 5.928v3.89c0 .556.926 1.853.926 2.779 0 2.964-3.89 5.187-6.484 5.187"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M5.445 10.822v-3.89c0-2.038 1.111-6.076 5.557-5.928 4.446.148 5.558 4.014 5.558 5.928v3.89c0 .556.926 1.853.926 2.779 0 2.964-3.89 5.187-6.484 5.187"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M5.446 10.822c0 .556-.926 1.853-.926 2.779 0 2.964 3.89 5.187 6.484 5.187M7.3 11.008V7.303c0-.741 1.63-2.78 3.704-2.78 2.075 0 3.89 2.039 3.89 2.78v3.705c-.185 1.235-1.26 3.52-4.075 3.52-2.223 0-3.52-2.286-3.52-3.52Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M8.78 13.786c.555.433 1.296 1.297 5.001 1.297"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

const Memo = memo(SvgFemale);
export default Memo;
